<template>
    <section class="bg-background-light pb-4 pt-4" :id="id">
        <div class="mx-auto max-w-[1200px] px-6 lg:px-10">
            <div class="relative overflow-hidden rounded-[2rem] bg-primary px-8 py-14 lg:px-16">
                <div class="pointer-events-none absolute inset-0" aria-hidden="true">
                    <div class="absolute -right-16 -top-16 h-72 w-72 rounded-full bg-white/20 blur-3xl"></div>
                    <div class="absolute -bottom-20 left-10 h-72 w-72 rounded-full bg-text-main/10 blur-3xl"></div>
                </div>

                <div class="relative">
                    <div class="max-w-[520px]">
                        <h2 class="text-3xl font-black tracking-tight text-text-main sm:text-4xl">{{ t('stats.title') }}</h2>
                        <p class="mt-2 text-lg font-medium text-text-main/70">{{ t('stats.subtitle') }}</p>
                    </div>

                    <dl class="mt-10 grid grid-cols-2 gap-x-6 gap-y-10" :class="gridClass">
                        <div v-for="s in visibleStats" :key="s.label" class="border-l-2 border-text-main/20 pl-5">
                            <dt class="text-4xl font-black tracking-tight text-text-main sm:text-5xl">{{ t(s.value) }}</dt>
                            <dd class="mt-1 text-sm font-semibold uppercase tracking-wide text-text-main/70">{{ t(s.label) }}</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { homeStats } from '../../data/stats';

defineProps<{ id?: string }>();

const { t } = useI18n();

// Stats still waiting for real numbers stay on the dev server.
const visibleStats = computed(() => homeStats.filter((s) => import.meta.env.DEV || !s.draft));

// Keep the row balanced however many stats are published.
const gridClass = computed(() => (visibleStats.value.length === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-4'));
</script>
